import * as React from 'react';
import { __, mapStateToProps, setTableParams, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import {
  createPlanningTemplate,
  listPlanningTemplates,
} from '../redux/actions/table/planning_library';
import PlanningTemplateForm from '../forms/planning_template/PlanningTemplateForm';
import AddTemplateIcon from '../assets/images/add-boq-template-group-60x60.svg';
import styles from '../styles/wizards/PlanningTemplateWizard.scss';
import {
  planningTemplateFromResponse,
  planningTemplateNodesToPayload,
} from '../views/company/PlanningTemplates/helpers';

const AddPlanningTemplateWizard = ({ draft, isSystem, onClose }) => {
  const handleSubmit = (formData) => {
    const data = {
      ...formData,
      nodes: planningTemplateNodesToPayload(draft.nodes),
    };

    return validateForm(
      createPlanningTemplate(data, isSystem).then(({ response }) => {
        setTableParams('planning_library', {
          template_draft: planningTemplateFromResponse(response.data),
          template_dirty: false,
        });
        listPlanningTemplates(isSystem);
        setNotification(__('planning-templates.template.saved'));
        onClose();
      }),
    );
  };

  return (
    <div className={styles.templateFormWizard}>
      <header className={styles.v3WizardHeader}>
        <div>
          <strong>
            {__('planning-templates.template.save-title')}
          </strong>
          <span>
            {__('planning-templates.template.save-subtitle')}
          </span>
        </div>
        <AddTemplateIcon />
      </header>
      <div className={styles.v3WizardBody}>
        <PlanningTemplateForm
          initialValues={{
            name: draft.name_translations,
            description: draft.description_translations || {},
            active: draft.active ? 1 : 0,
          }}
          onClose={onClose}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default mapStateToProps((state) => ({
  draft: state.table.planning_library.template_draft,
  isSystem: Boolean(
    _.get(state.table, 'planning_library.template_editor.isSystem', false),
  ),
}))(AddPlanningTemplateWizard);
